// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tag_wrapper__1LjUP","content":"Tag_content__oSC17"};